import type { FC } from 'react';

import { useTranslation } from '@mopla/i18';
import { useBreakpoints } from '@mopla/utils';

import { MplButton } from '../../../';
import { Responsive2ButtonsFooter } from '../../../layouts/Responsive2ButtonsFooter';

export interface IFormFooterProps {
	onCancel: VoidFunction;
	isSubmitDisabled: boolean;
}

export const FormFooter: FC<IFormFooterProps> = ({
	onCancel,
	isSubmitDisabled,
}) => {
	const { t } = useTranslation('profile');
	const { isMobile } = useBreakpoints();

	return (
		<Responsive2ButtonsFooter
			cancelBtn={
				<MplButton
					fullWidth
					className="cancelButton"
					variant="text"
					onClick={onCancel}
				>
					{t('button.abort')}
				</MplButton>
			}
			submitBtn={
				<MplButton
					fullWidth
					color={isMobile ? 'primaryRevert' : 'primary'}
					data-testid="EmailEditForm-submit-button"
					disabled={isSubmitDisabled}
					type="submit"
				>
					{t('button.save')}
				</MplButton>
			}
		/>
	);
};
